export default __webpack_public_path__ + "static/media/trashIcon.05e21f2f.svg";